export const CSS_VAR_REGEX = /^var\(--([^)]+)\)$/;

interface ResolveCssVariableProps {
  cssVariables: Record<string, string>;
  value: string;
  visitedVars?: Set<string>;
}

export const resolveCssVariable = ({
  value,
  cssVariables,
  visitedVars = new Set(),
}: ResolveCssVariableProps): string => {
  if (!value) {
    return value;
  }

  const match = CSS_VAR_REGEX.exec(value);

  if (!match) {
    return value;
  }

  const [, variableName] = match;

  if (visitedVars.has(variableName)) {
    console.warn(
      `Circular reference detected for CSS variable "${variableName}"`,
    );
    return value;
  }

  const resolvedValue = cssVariables[variableName];

  if (!resolvedValue) {
    console.warn(`CSS variable "${variableName}" not found in cssVariables`);
    return value;
  }

  const newVisitedVars = new Set(visitedVars);
  newVisitedVars.add(variableName);

  return CSS_VAR_REGEX.test(resolvedValue)
    ? resolveCssVariable({
        value: resolvedValue,
        cssVariables,
        visitedVars: newVisitedVars,
      })
    : resolvedValue;
};
